module.exports = __webpack_public_path__ + "static/img/thanh-serious-DxYTSX-bsuI-unsplash_thumb.b1775f2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/thanh-serious-DxYTSX-bsuI-unsplash_thumb.png
// module id = GJmD
// module chunks = 4